<div class="modal fade show d-block" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header User-Form">
        <h5 class="modal-title text-black">Update Subscription Details</h5>
        <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">

        <form class="row">
          <div class="col-md-6 mb-2">
            <app-date-picker [customClass]="'text-black'" [labelName]="'Select Date'" [fromDateFromParent]="userForm.billDate"
              [clearValue]="true" [inputDate]="userForm.billDate" (selectedDate)="userForm.billDate=$event" [disablePastDate]="false"
              [isRequired]="false" [placeholder]="'dd/MM/yyyy'" [dateFormat]="'dd/MM/yyyy'">
            </app-date-picker>
          </div>
        
          <div class="col-md-6 mb-2">
            <app-input [customClass]="'text-black'" [inputName]="'billSeries'" [inputType]="'text'" [inputId]="'billSeries'"
              [inputValue]="userForm.billSeries" [inputLabel]="'Bill Series'" [inputPlaceholder]="'Enter Bill Series'"
              (inputValueEmit)="userForm.billSeries = $event" [isRequired]="false">
            </app-input>
          </div>
        
          <div class="col-md-6 mb-2">
            <app-input [customClass]="'text-black'" [inputName]="'billNo'" [inputType]="'text'" [inputId]="'billNoId'"
              [inputValue]="userForm.billNo" [inputLabel]="'Bill Number'" [inputPlaceholder]="'Enter Bill Number'"
              (inputValueEmit)="userForm.billNo = $event" [isRequired]="false" [onlyNumbers]="true">
            </app-input>
          </div>
        
          <div class="col-md-6 mb-2">
            <app-input [customClass]="'text-black'" [inputName]="'amount'" [inputType]="'text'" [inputId]="'amount'"
              [inputValue]="userForm.amount" [inputLabel]="'Amount'" [inputPlaceholder]="'Enter Amount'"
              (inputValueEmit)="userForm.amount = $event" [isRequired]="false" [onlyNumbers]="true" [disabled]="true" [allowDecimal]="true">
            </app-input>
          </div>

          <div class="col-md-6 mb-2">
            <app-input [customClass]="'text-black'" [inputName]="'discount'" [inputType]="'text'" [inputId]="'discount'"
              [inputValue]="userForm.discount" [inputLabel]="'Discount'" [inputPlaceholder]="'Enter Discount'"
              (inputValueEmit)="userForm.discount = $event" [isRequired]="false" [onlyNumbers]="true" [disabled]="true" [allowDecimal]="true">
            </app-input>
          </div>

          <div class="col-md-6 mb-2">
            <app-input [customClass]="'text-black'" [inputName]="'netAmount'" [inputType]="'text'" [inputId]="'netAmount'"
              [inputValue]="userForm.netAmount" [inputLabel]="'Before Tax Amount'" [inputPlaceholder]="'Enter Before Tax Cost'"
              (inputValueEmit)="userForm.netAmount = $event" [isRequired]="false" [onlyNumbers]="true" [disabled]="true" [allowDecimal]="true">
            </app-input>
          </div>
        
          <div class="col-md-6 mb-2">
            <app-input [customClass]="'text-black'" [inputName]="'tax'" [inputType]="'text'" [inputId]="'tax'"
              [inputValue]="userForm.tax" [inputLabel]="'Tax Amount'" [inputPlaceholder]="'Enter Tax'"
              (inputValueEmit)="userForm.tax = $event" [isRequired]="false" [onlyNumbers]="true" [disabled]="true" [allowDecimal]="true">
            </app-input>
          </div>
        
          <div class="col-md-6 mb-2">
            <app-input [customClass]="'text-black'" [inputName]="'finalAmt'" [inputType]="'text'" [inputId]="'finalAmt'"
              [inputValue]="userForm.finalAmt" [inputLabel]="'Final Amount'" [inputPlaceholder]="'Enter Final Amount'"
              (inputValueEmit)="userForm.finalAmt = $event" [isRequired]="false" [onlyNumbers]="true" [disabled]="true" [allowDecimal]="true">
            </app-input>
          </div>
        
          <div class="col-md-6 mb-2 d-flex align-items-end">
            <div class="flex-grow-1">
              <app-input [customClass]="'text-black'" [inputName]="'reverseAmt'" [inputType]="'text'"
                [inputId]="'reverseAmt'" [inputValue]="userForm.reverseAmt" [inputLabel]="'Reverse Amount'"
                [inputPlaceholder]="'Enter Reverse Amount'" (inputValueEmit)="userForm.reverseAmt = $event" [isRequired]="false"
                [onlyNumbers]="true" [allowDecimal]="true" [decimalPlaces]="2">
              </app-input>
            </div>
          </div>

          <div class="col-md-6 mb-2 d-flex align-items-end">
            <app-button class="btns" [customClass]="'primary'" [buttonLabel]="'Re-Calculate'" (click)="recalculate()" [disabled]="userForm.reverseAmt <= 0">
            </app-button>
          </div>

        </form>

      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <app-button 
        class="btns btnRadius"
          [customClass]="'danger'"
          [buttonLabel]="'Close'"
          (click)="activeModal.dismiss()">
        </app-button>

        <app-button
        class="btns"
          [customClass]="'primary'"
          [buttonLabel]="'Save'"
          (click)="save()">
        </app-button>
      </div>

    </div>
  </div>
</div>